export default __webpack_public_path__ + "static/media/Landscaping.218cebf8.jpg";